export default __webpack_public_path__ + "static/media/EFA.823de204.webp";